import moment from 'moment';
import 'antd/dist/antd.css';
import HostFooter from './HostFooter';
import { push } from 'connected-react-router';
import { useParams, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Cell, Button } from 'react-md';
import { Menu, Dropdown, notification } from 'antd';
import UnifiedHostCalendar from './UnifiedHostCalendar';
import UnifiedCalendarDetailsModal from './Modals/UnifiedCalendarDetailsModal';
import { building, arrow, calendar, time, home, emailBlack, telephone, dropdownIcon, tick, redClose, arrowGreen} from '../Common/Images'
import useWindowDimensions from '../Common/Hooks/useWindowDimensions';
import { CALENDER_DATE_FORMAT } from '../../settings';
import { getCalenderVisitsData, updateVisitStatus, fetchSpaceDetails, getCalenderData, fetchSelectedBooking, sendBookingCancellation } from './HostDashboardActions';
import { SPACE_STATUS, CLEAR_CALENDAR_DATA } from './HostDashboardActionTypes';
import { EDIT, CREATE } from '../Common/constants';
import useAuth from '../../hooks/useAuth';
import { USER_HOST, ADMIN, DATE_FORMAT_REVERSE } from '../Common/constants'
import * as constants from './Common/HostDashboardConstants'

const EMPTY_OBJECT = {};

const Calendar = () => {
  const { user: loggedUser, isAuthenticated } = useAuth();
  const dispatch = useDispatch();
  const dimensions = useWindowDimensions();
  const { spaceId, status } = useSelector(state => state.router?.location?.query || EMPTY_OBJECT);
  
  const visitsData = useSelector((state) => state?.hostDashboard?.data?.calenderData?.schedulers || EMPTY_OBJECT);
  const bookingsData = useSelector((state) => state?.hostDashboard?.data?.calenderData?.bookings || EMPTY_OBJECT);
  const spaceDetails = useSelector((state) => state?.hostDashboard?.data?.spaceDetails || EMPTY_OBJECT);
  const authToken = useSelector((state) => state?.auth?.loginDetails?.data?.token || '');
  
  const headers = {
    'Content-Type': 'application/json',
    Authorization: authToken,
  };

  const { country } = useParams();
  const location = useLocation().search;
  const dateFromUrl = new URLSearchParams(location).get('startDate');

  const [visitsForTheDate, setVisitsForTheDate] = useState([]);
  const [bookingsForTheDate, setBookingsForTheDate] = useState([]);
  const [selectedDate, setSelectedDate] = useState(moment());
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);

  const mobileView = dimensions.width < 992;
  const isAdmin = loggedUser && loggedUser.authorities && (loggedUser.authorities[0] === ADMIN);

  useEffect(() => {
    if (!isAuthenticated) return;
    dispatch(fetchSpaceDetails(spaceId));
    handleDataFetch();
    
    return () => {
      dispatch({ type: CLEAR_CALENDAR_DATA });
    };
  },[isAuthenticated, spaceId]);

  useEffect(() =>{
    if (!isAuthenticated) return;
    if(dateFromUrl){
      setSelectedDate(moment(dateFromUrl,CALENDER_DATE_FORMAT));
    }
  },[dateFromUrl, isAuthenticated]);

  const handleDataFetch = () => {
    if (!isAuthenticated) return;
    const startMonth = moment().startOf('month').format(CALENDER_DATE_FORMAT);
    const endMonth = moment().add(3, 'months').format(CALENDER_DATE_FORMAT);
    const payload = {
      startDate: startMonth,
      endDate: endMonth,
    };
    dispatch(getCalenderVisitsData(spaceId, payload));
    dispatch(getCalenderData(spaceId, payload, headers));
  };

  const visitUpdateNotification = (status) => {
    notification.open({
      className: 'booking-cancellation-notification',
      message: (
        <span className="title">
          <img src={status ? tick : redClose} alt="arrow" className="icon" />
          <span className="text">{status ? 'Visit updated!' : 'Visit update failed!'}</span>
        </span>
      ),
      duration: 2,
      description: status ? 'You have successfully updated the visit.' : 'Visit update failed.Please try again',
    });
  };

  const handleStatus = (data, type) => {
    const { schedulerId:id } = data;
    dispatch(updateVisitStatus({ id, schedulerStatus: type === 1? SPACE_STATUS.ACTIVE:SPACE_STATUS.INACTIVE }, handleDataFetch, visitUpdateNotification));
  };

  const handleAcceptVisit = (visit) => handleStatus(visit, 1);
  const handleDeclineVisit = (visit) => handleStatus(visit, 2);

  const handleBack = () => {
    const URLtoPush = `/${country}/dashboard/myspaces/${status}/${spaceId}`;
    dispatch(push(URLtoPush));
  };

  const handleDateSelect = (date) => {
    setSelectedDate(date);
    const dateString = date.format('DD-MM-YYYY');
    
    // Visits
    let visits = [];
    if(Object.values(visitsData).length){
      visits = Object.values(visitsData).flatMap(i =>i).filter(item => item.schedulerStartDate === dateString);
    }
    setVisitsForTheDate(visits);
    
    // Bookings
    setBookingsForTheDate([]);
    
    setDetailsModalVisible(true);
  };
  
  const handlePanelChange = (date) => {
    setSelectedDate(date);
  };
  
  const handleEditBooking = (booking) => {
        notification.info({ message: 'Please go to "Manage Calendar" to edit bookings.' });
  };
  
  const handleCancelBooking = (booking) => {
       notification.info({ message: 'Please go to "Manage Calendar" to cancel bookings.' });
  };

  return (
    <>
      <div className="my-calendar host-dashboard manage-visit-wrap">
        <div className="content scrollwrap">
          <div className="container custom-container" style={{ width: '100%', maxWidth: 'none', padding: '20px' }}>
             <UnifiedHostCalendar 
                bookings={[]}
                visits={visitsData}
                selectedDate={selectedDate}
                onSelectDate={handleDateSelect}
                onPanelChange={handlePanelChange}
                spaceTitle={spaceDetails?.spaceName}
             />
          </div>
        </div>
        
        <UnifiedCalendarDetailsModal
            visible={detailsModalVisible}
            onCancel={() => setDetailsModalVisible(false)}
            date={selectedDate}
            bookings={bookingsForTheDate}
            visits={visitsForTheDate}
            onAcceptVisit={handleAcceptVisit}
            onDeclineVisit={handleDeclineVisit}
            onEditBooking={handleEditBooking} 
            onCancelBooking={handleCancelBooking}
            isAdmin={isAdmin}
        />
      </div>
      {mobileView && <HostFooter />}
    </>
  );
};

export default Calendar;
